module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dateFormat":{"pattern":"YYYY-MM-DD","timePattern":"hh:mm A"},"link":"Link (URL)","notSeen":"Not seen"},"fr":{"dateFormat":{"pattern":"DD/MM/YYYY","timePattern":"HH:mm"},"link":"Lien (URL)","notSeen":"Non vu"}}')
  delete Component.options._Ctor
}
